import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { reinstate, toggleReinstate } from 'entries/ducks';
import { isAtYourEntries } from 'entries/utils';
import ReinstateModal from 'entries/components/reinstate_modal';

const mapStateToProps = (state, { routes }) => {
  const { reinstatingEntry } = state.entries;
  const user = state.user.profile_data;

  return {
    entry: reinstatingEntry,
    user
  };
}

const mapDispatchToProps = (dispatch, { location, routes }) => {
  return bindActionCreators({
    reinstate: partial(reinstate, location.query, isAtYourEntries({ routes })),
    toggle: partial(toggleReinstate, null)
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReinstateModal));



// WEBPACK FOOTER //
// ./entries/containers/reinstate_modal.js